import { render, staticRenderFns } from "./SubsidioScorecardMelibrasil.vue?vue&type=template&id=bb2658ae&"
import script from "./SubsidioScorecardMelibrasil.vue?vue&type=script&lang=js&"
export * from "./SubsidioScorecardMelibrasil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports